import { render, staticRenderFns } from "./certType.vue?vue&type=template&id=1d0019d5"
import script from "./certType.vue?vue&type=script&lang=js"
export * from "./certType.vue?vue&type=script&lang=js"
import style0 from "./certType.vue?vue&type=style&index=0&id=1d0019d5&prod&lange=less&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports